import React from 'react';

export default class SourceModeButton extends React.Component {
  constructor(props) {
    super(props);
    this._toggleSourceCode = this._toggleSourceCode.bind(this);
  }

  _toggleSourceCode() {
    this.props.changeHandler({ type: 'toggleSourceMode' });
  }

  render() {
    return (
      <button
        className='source-code-button text-action-button'
        type='button'
        onClick={this._toggleSourceCode}
      >
        Edit source code
      </button>
    );
  }
}

SourceModeButton.propTypes = {
  changeHandler: React.PropTypes.func
};



// WEBPACK FOOTER //
// ./src/ui/inline-text/action-tab-content-components/source-mode-button.jsx